import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_ADMIN_CLOSURE_READINESS_API } from "./apiRoutes";

interface Props {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getClosureReadiness = async (projectId: string): Promise<any> => {
  return await axiosAuth.get(`${DASHBOARD_ADMIN_CLOSURE_READINESS_API(projectId)}`);
};

const useGetClosureReadiness = ({ projectId, queryParams }: Props): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-pm-closure-readiness", projectId],
    queryFn: () => getClosureReadiness(projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!projectId,
    ...queryParams,
  });
};

export default useGetClosureReadiness;
